/**
 * 配网配置接口
 *
 * 后端：iotPlatformService controller/admin/v2/pairing，需求文档 docs/pairing-config-api.md。
 * 返回结构与 axios/fetch 一致：{ data: { code, data, msg } }，页面按 res.data.code == 200 判断。
 * 方法名沿用 mock 阶段的命名，页面不用改。
 */
import { ElMessage } from 'element-plus'
import { fetch } from '../../../axios/fetch'

const base = '/admin/v1/'

// 查询接口：失败时统一提示并中断，页面里的读取逻辑只处理成功的情况
const get = (url, params) =>
    fetch({ url: base + url, method: 'get', params: params || {} }).then((res) => {
        if (res.data.code != 200) {
            ElMessage.error('获取失败' + (res.data.msg || ''))
            return Promise.reject(res)
        }
        return res
    })

// 写入接口：原样返回，由页面按 code 提示成功或失败原因
const post = (url, data) => fetch({ url: base + url, method: 'post', data: data || {} })

export default {
    PairingMeta: () => get('pairing/meta'),

    // 分类列表：不传 app 返回全部；传 app 只返回该 App 可用的分类，sort 为该 App 的排序
    PairingCategoryList: (params) => get('pairing/category/list', params),
    // apps 为适用 App（client_app.code 数组），空数组表示所有 App 可用
    PairingCategorySave: (params) => post('pairing/category/save', params),
    PairingCategoryDelete: (params) => post('pairing/category/delete', params),
    // 排序：ids 为当前视图下的行顺序；app 为空改基础排序，非空只写该 App 的排序
    PairingCategorySort: (params) => post('pairing/category/sort', params),

    // 型号列表：app 只返回该 App 可见的型号，sort 为该 App 的排序（没配则基础排序）
    PairingModelList: (params) => get('pairing/model/list', params),
    PairingModelSave: (params) => post('pairing/model/save', params),
    PairingModelDelete: (params) => post('pairing/model/delete', params),
    // 排序：codes 为同一分类内的新顺序；app 为空改基础排序，非空只写该 App 的排序
    PairingModelSort: (params) => post('pairing/model/sort', params),

    PairingSchemeList: (params) => get('pairing/scheme/list', params),
    PairingSchemeSave: (params) => post('pairing/scheme/save', params),
    PairingSchemeDelete: (params) => post('pairing/scheme/delete', params),
    PairingSchemeSort: (params) => post('pairing/scheme/sort', params),

    // product_model 为具体型号的内部型号（client_product_model.model）
    PairingProductModelDetail: (params) => get('pairing/product_model/detail', params),
    PairingProductModelAssign: (params) => post('pairing/product_model/assign', params),

    // 文案库：方案引导文案、版本提示、方案名、分类名都引用这里的 code
    TextList: (params) => get('pairing/text/list', params),
    TextDetail: (params) => get('pairing/text/detail', params),
    TextSave: (params) => post('pairing/text/save', params),
    TextDelete: (params) => post('pairing/text/delete', params),

    // 字典：功能、能力字段、灯效预设、复位颜色、图片类型、文案用途、支持语言，pairing/meta 由此生成
    DictList: (params) => get('pairing/dict/list', params),
    DictSave: (params) => post('pairing/dict/save', params),
    DictDelete: (params) => post('pairing/dict/delete', params),
    DictSort: (params) => post('pairing/dict/sort', params),

    // 设备能力，未配置时 data 为 null
    CapabilityDetail: (params) => get('capability/detail', params),
    CapabilitySave: (params) => post('capability/save', params),
    CapabilityDelete: (params) => post('capability/delete', params),

    // 下发预览，结构与原 osaio_IPCFunctionTable / osaio_IPCBlueToothTable 一致
    AppFunctionTable: ({ productModel } = {}) =>
        get('pairing/function_table', productModel ? { product_model: productModel } : {}),
    AppBleTable: () => get('pairing/ble_table'),
}
